import { RoleUser } from "@homesusa/core";
import type { StatusPillVariant } from "@homesusa/layout";

export const RoleUserPillVariant: Record<RoleUser, StatusPillVariant> = {
  [RoleUser.User]: "neutral",
  [RoleUser.MLSAdministrator]: "info",
  [RoleUser.Photographer]: "warning"
};
